import Grid from "@material-ui/core/Grid";
import React from "react";

import * as Styles from "../styles/ViewLotStyles";

import { Box, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { useHistory } from "react-router";
import { Auction, useAuctionFees } from "../../../services/AuctionService";
import BidGridComponent from "../../bid/BidGridComponent";
import MediaContainer from "../lot-images/MediaContainer";
import { SellerCard } from "../seller/SellerCard";
import TitleContainer from "../title/TitleContainer";
import VehicleLotDetailsContainer from "./lot-details/VehicleLotDetailsContainer";

interface ViewLotProps {
  auction: Auction;
}

const VehicleViewLot: React.FC<ViewLotProps> = ({ auction }) => {
  const classes = Styles.ViewLotStyles();
  const history = useHistory();

  const backToListings = () => {
    // Retrieve the saved query string..
    const queryString = localStorage.getItem('queryString');

    // Navigate back to the search page with the query string..
    history.push(`/Search${queryString}`);
  };

  const [auctionFee, auctionFeeLoading] = useAuctionFees(auction.id, () => {
    enqueueSnackbar("There was a problem loading the auction fee, please try again.", { variant: "error" });
  });

  const hasCustomerHammerFees = () => {
    return auctionFee?.bespokeBands !== null;
  }

  return (
    <Grid container spacing={5}>
      {(!auctionFeeLoading && hasCustomerHammerFees()) && (
        <Grid item xs={12}>
          <Box
            bgcolor="primary.main"
            color="primary.contrastText"
            className={classes.warningMessageContainer}
            p={2}
          >
            <Typography className={classes.textLayout}>
              <InfoIcon className={classes.iconPosition} />
              This auction has bespoke auction fee's associated, please see the 'Auction Fee's' tab below
            </Typography>
          </Box>
        </Grid>
      )}

      <Grid item xs={12} sm={12} md={6} lg={8} xl={8}>
        <MediaContainer lotId={auction.lotId} lotMediaCacheName={auction.lotMediaCacheName} />
      </Grid>

      <Grid className={classes.bidContainer} item xs={12} sm={12} md={6} lg={4} xl={4}>
        <TitleContainer auction={auction} />
        <BidGridComponent auction={auction} isWatchlistMode={false} auctionUpdated={() => { }} />
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent="center" style={{ marginTop: '1.25rem' }}>
          <Typography onClick={backToListings} style={{ fontWeight: 500, textDecoration: 'underline', cursor: 'pointer' }}>
            &lt; Back to Listings
          </Typography>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={8} xl={8}>
        <SellerCard auction={auction} />
      </Grid>

      <Grid item xs={12}>
        <VehicleLotDetailsContainer auction={auction} />
      </Grid>
    </Grid>
  );
};

export default VehicleViewLot;
function enqueueSnackbar(arg0: string, arg1: { variant: string; }) {
  throw new Error("Function not implemented.");
}

